export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/register",
    RESET_PASSWORD: "/reset-password",
    COMPANY_SELECTION: "/company-selection",

    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
    get COMPANY_SELECTION_PAGE() { return `${this.AUTH}${this.COMPANY_SELECTION}`; },
}

export const NAVIGATE_MODULE = {
    HOME: "/",
    USER:'/user',
    get HOME_PAGE() { return `${this.HOME}`; },
}

export const ERROR = {
    ERROR_403: "/403",
    get ERROR_403_PAGE() { return `${this.ERROR_403}`; },
}

export const NAVIGATE_ADMIN = {
    ADMIN: "/admin",
    
    DASHBOARD: "/dashboard",
    SETTINGS: "/settings",
    get DASHBOARD_PAGE() { return `${this.ADMIN}${this.DASHBOARD}`; },
    get SETTINGS_PAGE() { return `${this.ADMIN}${this.SETTINGS}`; },
}

export const NAVIGATE_MASTERS = {
    MASTERS: "/masters",
    CUSTOMER_MATSER: "/customers",
    CUSTOMER_GROUP_MASTER: "/customer-groups",
    PRODUCT_MASTER: "/products",
    PORTS_MASTER: "/ports",
    UNITS_MASTER: "/units",
    PACKAGES_MASTER: "/packages",
    INVENTORY_MASTER: "/inventory",
    PAYMENT_TERMS_MASTER: "/payment-terms",
    SHIPMENT_TERMS_MASTER: "/shipment-terms",
    CURRENCIES_MASTER: "/currencies",
    QUALITY_SPECIFICATION_MASTER: "/quality-specifications",
    BANK_DETAILS_MASTER: "/bank-details",
    LICENSE_MASTER: "/licenses",
    VENDOR_MASTER: "/vendors",
    DELIVERY_ADDRESS_MASTER: "/delivery-address",
    NUMBERING_SETUP_MASTER: "/numbering-setup",
    LC_MASTER :"/lc-master",
    COA_SETTING: "/coa-setting",
    DYNAMIC_FIELDS: "/dynamic-fields",
    LABEL_PARAMETER:"/label-parameter",
    SALE_USERS: "/sales-person",
    BROKER_USERS: "/broker-users",
    DOCUMENTS: "/documents",
    DOCUMENT_TEMPLATES: "/document-templates",
    DYNAMIC_TEMPLATES: "/dynamic-templates",
    EMAIL_TEMPLATES: "/email-templates",
    TERMS_CONDITIONS: "/terms-conditions",
    PRRFIX: "/prefix",
    SUFFIX: "/suffix",
    COMPANY_DETAILS: "/company",
    DECLARATION: "/declarations",
    REMARKS: "/remarks",
    ROLE: "/roles",
    SMTP_SETTINGS: "/smtp",
    BRANCH: '/branch',
    EXPENSE_TYPE: '/expense-type',

    get MASTERS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}`; },
    get CUSTOMER_MATSER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.CUSTOMER_MATSER}`; },
    get CUSTOMER_GROUP_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.CUSTOMER_GROUP_MASTER}`; },
    get COMPANY_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.COMPANY_DETAILS}`; },
    get PRODUCT_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.PRODUCT_MASTER}`; },
    get PORTS_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.PORTS_MASTER}`; },
    get UNITS_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.UNITS_MASTER}`; },
    get PACKAGES_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.PACKAGES_MASTER}`; },
    get INVENTORY_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.INVENTORY_MASTER}`; },
    get PAYMENT_TERMS_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.PAYMENT_TERMS_MASTER}`; },
    get SHIPMENT_TERMS_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.SHIPMENT_TERMS_MASTER}`; },
    get CURRENCIES_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.CURRENCIES_MASTER}`; },
    get QUALITY_SPECIFICATION_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.QUALITY_SPECIFICATION_MASTER}`; },
    get BANK_DETAILS_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.BANK_DETAILS_MASTER}`; },
    get LICENSE_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.LICENSE_MASTER}`; },
    get VENDOR_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.VENDOR_MASTER}`; },
    get DELIVERY_ADDRESS_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.DELIVERY_ADDRESS_MASTER}`; },
    get NUMBERING_SETUP_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.NUMBERING_SETUP_MASTER}`; },
    get LC_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.LC_MASTER}`; },
    get COA_SETTING_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.COA_SETTING}`; },
    get DYNAMIC_FIELDS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.DYNAMIC_FIELDS}`; },
    get LABEL_PARAMETER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.LABEL_PARAMETER}`; },
    get SALE_USERS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.SALE_USERS}`; },
    get BROKER_USERS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.BROKER_USERS}`; },
    get DOCUMENTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.DOCUMENTS}`; },
    get DOCUMENT_TEMPLATES_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.DOCUMENT_TEMPLATES}`; },
    get DYNAMIC_TEMPLATES_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.DYNAMIC_TEMPLATES}`; },
    get EMAIL_TEMPLATES_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.EMAIL_TEMPLATES}`; },
    get TERMS_CONDITIONS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.TERMS_CONDITIONS}`; },
    get PRRFIX_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.PRRFIX}`; },
    get SUFFIX_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.SUFFIX}`; },
    get DECLARATION_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.DECLARATION}`; },
    get REMARKS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.REMARKS}`; },
    get ROLES_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.ROLE}`; },
    get SMTP_SETTINGS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.SMTP_SETTINGS}`; },
    get BRANCH_MASTER_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.BRANCH}`; },
    get EXPENSE_TYPE_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.MASTERS}${this.EXPENSE_TYPE}`; },
}

export const NAVIGATE_UTILITY = {
    UTILITY: "/utility",
    get UTILITY_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.UTILITY}`; },
}

export const NAVIGATE_PROFORMA_INVOICE = {
    PROFORMA_INVOICE: "/proforma-invoice",
    get PROFORMA_INVOICE_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.PROFORMA_INVOICE}`; },
}

export const NAVIGATE_SETUP_SECTIONS = {
    SETUP_SECTIONS: "/setup",
    get SETUP_SECTIONS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.SETUP_SECTIONS}`; },
}

export const NAVIGATE_REPORTS = {
    REPORTS: "/reports",
    SHIPMENT: "/shipment",
    COUNTRY_REPORT: "/shipment/country",
    CURRENCY_REPORT: "/shipment/currency",
    ALL_REPORTS: "/",
    PI_CURRENCY_REPORT: "/pi/currency",
    PI_COUNTRY_REPORT: "/pi/country",
    PI_CUSTOMER_REPORT: "/pi/customer",
    PI_DATE_WISE_REPORT: "/pi/date-wise",
    PI_PENDING_REPORT: "/pi/pending",
    INVOICE_REPORT:{
        COUNTRY_REPORT: "/invoice/country",
        CURRENCY_REPORT: "/invoice/currency",
        CUSTOMER_REPORT: "/invoice/customer",
        DATE_WISE_REPORT: "/invoice/date",
    },

    IRM_REPORT:"/irm",
    BRC_REPORT:"/brc",

    PAYMENT_REPORTS: {
        COUNTRY_REPORT: "/payment/country",
        CURRENCY_REPORT: "/payment/currency",
        CUSTOMER_REPORT: "/payment/customer",
        INVOICE_REPORT: "/payment/invoice",
    },
    EXPENSE_REPORTS: {
        PI_REPORT: "/expense/pi-type",
        INVOICE_REPORT: "/expense/invoice-type",
    },
    BROKERAGE_REPORTS: {
        CONTRACT_REPORT: "/brokerage/contract",
        PURCHASE_REPORT: "/brokerage/purchase",
    },

    get REPORTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.REPORTS}`; },
}

export const NAVIGATE_EXPORT_DOCS = {
    EXPORT_DOCS: "/export-docs",
    INVOICES: "/invoices",
    PRE_SHIPMENT_DOCS: {
        PRE_SHIPMENT_DOCS: "/pre-shipment-docs",
        DOCUMENTS: "/documents",
    },
    POST_SHIPMENT_DOCS: {
        POST_SHIPMENT_DOCS: "/post-shipment-docs",
        DOCUMENTS: "/documents",
    },
    BL_DRAFT: "/bl-draft",
    PACKING_LIST_DETAILED: "/packing-list-detailed",
    INVOICE_DOCS: "/invoice-docs",

    get EXPORT_DOCS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPORT_DOCS}`; },
    get PRE_SHIPMENT_DOCS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPORT_DOCS}${this.PRE_SHIPMENT_DOCS.PRE_SHIPMENT_DOCS}`; },
    get POST_SHIPMENT_DOCS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPORT_DOCS}${this.POST_SHIPMENT_DOCS.POST_SHIPMENT_DOCS}`; },
    get POST_SHIPMENT_DOCUMNETS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPORT_DOCS}${this.POST_SHIPMENT_DOCS.POST_SHIPMENT_DOCS}${this.POST_SHIPMENT_DOCS.DOCUMENTS}`; },
    get BL_DRAFT_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPORT_DOCS}${this.BL_DRAFT}`; },
    get PACKING_LIST_DETAILED_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPORT_DOCS}${this.PACKING_LIST_DETAILED}`; },
    get INVOICES_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPORT_DOCS}${this.INVOICES}`; },

}

export const NAVIGATE_ARCHIVE = {
    ARCHIVE: "/archive",
    INVOICE_DOCS: "/invoice-docs",
    get ARCHIVE_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.ARCHIVE}`; },
    get ARCHIVE_INVOICE_DOCS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.ARCHIVE}${this.INVOICE_DOCS}`; },
}

export const NAVIGATE_FINAL_SET = {
    FINAL_SET: "/final-set",
    INVOICE_DOCS: "/invoice-docs",
    get FINAL_SET_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.FINAL_SET}`; },
    get FINAL_SET_INVOICE_DOCS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.FINAL_SET}${this.INVOICE_DOCS}`; },
}

export const NAVIGATE_PAYMENT_LEDGER = {
    PAYMENT_LEDGER: "/payments",
    TRANSACTIONS: "/transactions",
    get PAYMENT_LEDGE_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.PAYMENT_LEDGER}`; },
    get TRANSACTIONS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.PAYMENT_LEDGER}${this.TRANSACTIONS}`; },
}

export const NAVIGATE_PURCHASE = {
    PURCHASE: "/purchase",
    PURCHASE_ORDER: "/order",
    PURCHASE_VENDOR_CREDIT: "/vendor-credit",
    PURCHASE_ORDER_PENDING: "/pending"   
}

export const NAVIGATE_INVENTORY = {
    INVENTORY: "/inventory",
    TYPES: "/types",
    get INVENTORY_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.INVENTORY}`; },
    get TYPES_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.INVENTORY}${this.TYPES}`; },
}

export const NAVIGATE_EXPENSES = {
    EXPENSES: "/expenses",
    get EXPENSES_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.EXPENSES}`; },
}

export const NAVIGATE_CHECKLIST = {
    CHECKLIST: "/checklist",
    get CHECKLIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.CHECKLIST}`; },
}

export const NAVIGATE_USERS = {
    USERS: "/users",
    ALL_USERS: "/",
    COMPANY_REGISTER: "/company-register",
    COMPANY_DETAILS: "/company-details",
    USERS_ROLES_MASTER: "/roles-master",

    get USERS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.USERS}`; },
    get COMPANY_DETAILS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.USERS}${this.COMPANY_DETAILS}`; },
    
    get COMPANY_COMPANY_REGISTER_PAGE() { return `${NAVIGATE_AUTH.AUTH}${this.COMPANY_REGISTER}`; },
}

export const NAVIGATE_IRM = {
    IRM: "/irm",
    get IRM_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.IRM}`; },
}

export const NAVIGATE_BRC = {
    BRC: "/brc",
    BRC_CREATE: "/create",
    get BRC_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.BRC}`; },
    get BRC_CREATE_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.BRC}${this.BRC_CREATE}`; },

}

export const NAVIGATE_ORM = {
    ORM: "/orm",
    get ORM_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.ORM}`; },
}

export const NAVIGATE_ROLES_PERMISSION = {
    ROLES_PERMISSION: "/roles_permissions",
    get ROLES_PERMISSION_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.ROLES_PERMISSION}`; },
}

export const NAVIGATE_ACTIVITY_LOG = {
    ACTIVITY_LOG: "/activity-log",
    get ACTIVITY_LOG_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.ACTIVITY_LOG}`; },
}
